
const digest = 'a929def559e705e343f1d156a59371994f8307cb61d90209952e735499010cc0';
const classes = {"wrapper":"_wrapper_1qlbd_1","content":"_content_1qlbd_10"};
const css = `._wrapper_1qlbd_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  flex-grow: 1;
  height: 100%;
  background-color: #ffffff;
  overflow: hidden;
}
._wrapper_1qlbd_1 ._content_1qlbd_10 {
  border: 1px solid #eaedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  